export default __webpack_public_path__ + "static/media/sneaker.b50d534b.png";